<script>
/**
 * Footer Component
 */
export default {}
</script>

<template>
<!-- Footer Start -->
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                {{ new Date().getFullYear()}} &copy; Hecho por Emisión con &hearts;
            </div>
            <div class="col-md-6">
                <div class="text-md-right footer-links d-none d-sm-block">
                  
                    <!-- <a href="javascript:void(0);">Ayuda</a>-->
                    <a href="javascript:void(0);">Contactos</a>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- end Footer -->
</template>
